import { render, staticRenderFns } from "./DocumentsContractorProjectFilters.vue?vue&type=template&id=2fc44fa4"
import script from "./DocumentsContractorProjectFilters.vue?vue&type=script&lang=ts"
export * from "./DocumentsContractorProjectFilters.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fc44fa4')) {
      api.createRecord('2fc44fa4', component.options)
    } else {
      api.reload('2fc44fa4', component.options)
    }
    module.hot.accept("./DocumentsContractorProjectFilters.vue?vue&type=template&id=2fc44fa4", function () {
      api.rerender('2fc44fa4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/documents/filters/DocumentsContractorProjectFilters.vue"
export default component.exports